import { Flex, Grid } from '@chakra-ui/react';
import { useCallback } from 'react';
import { IconButton } from 'ui-components/dist/Button';
import { PlusIcon } from 'ui-components/dist/PlusIcon';
import { useAddNewPlatformsStore } from '~/screens/ManagePlatforms/AddNewPlatformsModal';
import {
  Platform,
  useEditPlatformsStore,
} from '~/screens/ManagePlatforms/EditPlatformsModal_DEPRECATED';
import { useGetAvailablePlatforms } from '~/screens/ManagePlatforms/hooks';

export const Platforms: React.FC = () => {
  const { closeModal: closeEditPlatform, connectedPlatforms } =
    useEditPlatformsStore();
  const { setIsModalOpen: openAddNewPlatform } = useAddNewPlatformsStore();

  const availablePlatforms = useGetAvailablePlatforms(connectedPlatforms);

  const handleAddNewPlatformClick = useCallback(() => {
    closeEditPlatform();
    openAddNewPlatform(true);
  }, [closeEditPlatform, openAddNewPlatform]);

  return (
    <Flex gap={6} flexWrap="wrap" alignItems="stretch" justifyItems="center">
      {connectedPlatforms.map((platform, index) => (
        <Platform platform={platform} key={index} />
      ))}
      <Grid alignItems="center">
        <IconButton
          aria-label="Add new platforms"
          variant="tertiary"
          size="md"
          onClick={handleAddNewPlatformClick}
          isDisabled={!(availablePlatforms.length > 0)}
          icon={<PlusIcon boxSize={4} color="primary.700" />}
        />
      </Grid>
    </Flex>
  );
};
